import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { colors, typography } from '../styles/theme';
import {
  SHARE_PERSON_ROLE_EDITOR,
  SHARE_PERSON_ROLE_VIEWER,
} from '../Map/utils/sharePeopleRoles';

const TEXT_SECONDARY = '#ABABAB';
const TEXT_PRIMARY = '#F9FAFB';

const selectSx = {
  minWidth: 118,
  height: 32,
  fontSize: '12px',
  fontFamily: typography.fontFamily.primary,
  color: TEXT_SECONDARY,
  bgcolor: 'transparent',
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '& .MuiSelect-select': { py: 0.75, px: 1, pr: '28px !important' },
  '& .MuiSelect-icon': { color: TEXT_SECONDARY },
};

const menuPaperSx = {
  bgcolor: colors.backgroundSurface,
  backgroundImage: 'none',
  border: `1px solid ${colors.border}`,
};

const itemSx = {
  fontFamily: typography.fontFamily.primary,
  fontSize: '13px',
  color: TEXT_PRIMARY,
};

/**
 * Rol de una persona en Compartir restringido. Por defecto puede ver.
 */
export default function SharePersonRoleSelect({ value, onChange, disabled = false, email }) {
  const role = value === SHARE_PERSON_ROLE_EDITOR
    ? SHARE_PERSON_ROLE_EDITOR
    : SHARE_PERSON_ROLE_VIEWER;
  return (
    <Select
      size="small"
      value={role}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value)}
      aria-label={`Permiso de ${email || 'esta persona'}`}
      sx={selectSx}
      MenuProps={{ PaperProps: { sx: menuPaperSx } }}
    >
      <MenuItem value={SHARE_PERSON_ROLE_VIEWER} sx={itemSx}>Puede ver</MenuItem>
      <MenuItem value={SHARE_PERSON_ROLE_EDITOR} sx={itemSx}>Editor</MenuItem>
    </Select>
  );
}
